import { Tag } from "@p0security/ui";

/*
/**
 * A simple component that displays a colored tag indicator
 * @component
 
 * @param color - The color to display in the tag
 * @param className - Optional classes to apply to the tag
 * @returns {JSX.Element} A rectangular component with the provided color
 * @example
 * <ColorCodeIndicator color="blue" />
 * <ColorCodeIndicator color="#ff0000" className="m-2" />
 */

export const ColorCodeIndicator: React.FC<{
  className?: string;
  color: string;
}> = ({ className, color }) => {
  return <Tag className={className} color={color} />;
};
